<template>
  <div class="case-page">
    <banner title="经典案例" />
    <section class="case-panel" v-loading="loading">
      <div class="case-grid" v-if="caseList.length">
        <article class="case-card" v-for="cas in caseList" :key="cas.id">
          <router-link class="case-link" :to="{ name: 'casedetails', params: { id: cas.id }}">
            <div class="case-img" v-lazy:background-image="imgserver + cas.img"></div>
            <div class="case-body">
              <h3>{{ cas.title || cas.Title }}</h3>
              <p>{{ formatContent(cas.content) }}</p>
              <span class="case-more">查看详情 <i class="el-icon-right"></i></span>
            </div>
          </router-link>
        </article>
      </div>
      <div class="empty-state" v-else-if="!loading">
        <i class="el-icon-folder-opened"></i>
        <p>暂无案例数据</p>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      caseList: []
    };
  },
  methods: {
    formatContent(content) {
      if (!content) return "";
      return content.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
    }
  },
  mounted() {
    this.$http
      .get("Case")
      .then(response => {
        this.caseList = response.result || [];
      })
      .catch(error => {
        window.console.log(error);
        this.caseList = [];
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
.case-page {
  min-height: 100%;
  background: #eef4f8;
}

.case-panel {
  width: min(1180px, 92%);
  margin: -34px auto 56px;
  padding: 36px;
  box-sizing: border-box;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 22px 58px rgba(18, 48, 78, 0.12);
  position: relative;
  z-index: 2;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 22px;
}

.case-card {
  min-height: 388px;
  border: 1px solid #e3edf5;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 30px rgba(20, 34, 53, 0.06);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;
}

.case-card:hover {
  transform: translateY(-5px);
  border-color: rgba(44, 172, 226, 0.38);
  box-shadow: 0 22px 42px rgba(20, 34, 53, 0.12);
}

.case-link {
  height: 100%;
  display: flex;
  flex-direction: column;
  color: inherit;
  text-decoration: none;
}

.case-img {
  height: 210px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #dbe8f1;
}

.case-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 22px;
}

.case-body h3 {
  color: #142235;
  font-size: 21px;
  line-height: 1.45;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.case-body p {
  margin-top: 12px;
  color: #607286;
  font-size: 14px;
  line-height: 1.75;
  height: 74px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.case-more {
  margin-top: auto;
  padding-top: 18px;
  color: #156da8;
  font-size: 14px;
  font-weight: 700;
}

.empty-state {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #7d8fa3;
}

.empty-state i {
  font-size: 42px;
  color: #b7c7d8;
}

.empty-state p {
  margin-top: 12px;
  font-size: 16px;
}

@media (max-width: 680px) {
  .case-panel {
    width: 94%;
    padding: 22px 16px 34px;
  }
}
</style>
